import React from 'react';
import { SubscriptionPlanIconGlyph, subscriptionPlanBadgeStyle } from '../../utils/subscriptionPlanIcon';
import type { ActiveSubscriptionPlanBadgeInfo } from '../../utils/normalizeSubscriptionStatus';

interface ActiveSubscriptionPlanBadgeProps {
  plan: ActiveSubscriptionPlanBadgeInfo;
  className?: string;
  title?: string;
}

/** Compact plan icon on subscription tab — same size as the messages unread count badge. */
export const ActiveSubscriptionPlanBadge: React.FC<ActiveSubscriptionPlanBadgeProps> = ({
  plan,
  className = 'absolute -top-1 -right-1 z-10',
  title
}) => (
  <span
    className={`${className} flex h-4 w-4 sm:h-5 sm:w-5 items-center justify-center rounded-full border-2 border-white dark:border-gray-900 shadow-lg overflow-hidden`}
    style={subscriptionPlanBadgeStyle(plan.color)}
    title={title ?? `Active plan: ${plan.planName}`}
    aria-label={title ?? `Active plan: ${plan.planName}`}
  >
    <SubscriptionPlanIconGlyph
      icon={plan.icon ?? null}
      color={plan.color ?? null}
      className="h-2.5 w-2.5 sm:h-3 sm:w-3"
    />
  </span>
);

export default ActiveSubscriptionPlanBadge;
